import { STATUS_PHASES } from "@/lib/status";

const PHASE_STYLES = {
  done: {
    icon: "border-brand-orange/30 bg-brand-orange/10 text-brand-orange",
    label: "text-brand-orange",
  },
  active: {
    icon: "border-brand-blue/40 bg-brand-blue/10 text-brand-blue",
    label: "text-brand-blue",
  },
  next: {
    icon: "border-white/12 bg-white/[0.04] text-white/50",
    label: "text-white/40",
  },
};

/**
 * „Der Weg zum Start“: die Phasen aus src/lib/status.js als senkrechte Liste.
 * Steht im Hinweis auf der Kontaktseite und auf der Warteliste.
 */
export const StatusPhases = () => (
  <ol className="space-y-8">
    {STATUS_PHASES.map((phase, i) => {
      const Icon = phase.icon;
      const style = PHASE_STYLES[phase.state];
      const isLast = i === STATUS_PHASES.length - 1;
      return (
        <li key={phase.state} className="relative flex gap-5">
          {!isLast && (
            <span
              aria-hidden="true"
              className="absolute left-[22px] top-12 -bottom-8 w-px -translate-x-1/2 bg-white/10"
            />
          )}
          <span
            className={`relative flex items-center justify-center w-11 h-11 shrink-0 rounded-xl border ${style.icon}`}
          >
            <Icon className="w-[18px] h-[18px]" />
            {phase.state === "active" && (
              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-brand-blue shadow-[0_0_10px_2px_rgba(0,122,255,0.8)] animate-pulse" />
            )}
          </span>
          <div>
            <span
              className={`block text-[11px] uppercase tracking-[0.2em] font-bold ${style.label}`}
            >
              {phase.label}
            </span>
            <p className="mt-1 font-display font-bold text-lg md:text-xl text-white">
              {phase.title}
            </p>
            <p className="mt-1 text-sm md:text-base leading-relaxed text-white/55">
              {phase.text}
            </p>
          </div>
        </li>
      );
    })}
  </ol>
);
